{% block sw_cms_element_acris_faq %}
    <div class="sw-cms-el-acris-faq">
{#        <div v-for="item in faqElements" class="acris-faq-accordion-wrapper">#}
{#            <a v-for="faq in item.faqs" href="#"#}
{#               role="button"#}
{#               aria-expanded="false">#}
{#                {{ faq.name }}#}
{#                <span>+</span>#}
{#            </a>#}
{#        </div>#}

        <div class="acris-faq-question-title">
            <p>Lorem ipsum?</p><span>+</span>
        </div>
        <div class="acris-faq-question-content">
            <p>Lorem ipsum dolor sit amet.</p>
        </div>

    </div>
{% endblock %}
